namespace GeniuzPOS.InitialData {
    export class PsDiscCouponTypeMbColumns {
        static columnsKey = 'InitialData.PsDiscCouponTypeMb';
    }
}
